import { render, staticRenderFns } from "./ClientManagement.vue?vue&type=template&id=234e8d58&scoped=true&"
import script from "./ClientManagement.vue?vue&type=script&lang=js&"
export * from "./ClientManagement.vue?vue&type=script&lang=js&"
import style0 from "./ClientManagement.vue?vue&type=style&index=0&id=234e8d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234e8d58",
  null
  
)

export default component.exports